import LoadingButtonProvider from '@/components/buttons/LoadingButtonProvider';
import useToast from '@/hooks/useToast';
import { ECollectionStatus } from '@/interfaces/doccen-lib/contentManagement.interface';
import { postPublishDoccenCollection } from 'apis/tms/library/collection.api';
import { PATH_NAME } from 'configs/pathName';
import { Button } from 'design-system/components/Button';
import { Icon } from 'design-system/components/Icon';
import Typography from 'design-system/components/Typography/Typography';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { useMutation } from 'react-query';
import { CollectionDetailContext } from 'state/collection/CollectionDetailProvider';

const CollectionDetailOwnerStatusInteraction = ({
  fallbackElement = null,
}: {
  fallbackElement: React.ReactElement | null;
}) => {
  const { collection } = useContext(CollectionDetailContext);
  const router = useRouter();
  const toast = useToast();

  const { mutate: handlePublishCollection, isLoading } = useMutation({
    mutationFn: postPublishDoccenCollection,
    onSuccess: (data) => {
      router.push({
        pathname: PATH_NAME.LIBRARY_COLLECTION_DETAIL,
        query: { cid: data.id },
      });
    },
    onError: () => {
      toast('Xuất bản bộ sưu tập thất bại', 'error');
    },
  });

  const status = collection?.status;

  if (status === ECollectionStatus.Editing) {
    return (
      <div className="mx-auto flex w-[350px] items-center gap-3 rounded-[10px] bg-Other/Warninggeneral px-3 py-2 text-white">
        <Icon iconName="info-circle" variant="solid" />
        <Typography variant="body4">
          Bạn đã thay đổi nội dung. Hãy xuất bản lại để mọi người có thể thấy
          được nội dung đó
        </Typography>
        <LoadingButtonProvider
          isLoading={isLoading}
          className="flex-shrink-0 whitespace-nowrap rounded-full"
        >
          <Button
            onClick={() => {
              collection?.collectionId &&
                handlePublishCollection(collection.collectionId);
            }}
          >
            Xuất bản
          </Button>
        </LoadingButtonProvider>
      </div>
    );
  }

  if (
    status === ECollectionStatus.Draft ||
    status === ECollectionStatus.Hidden
  ) {
    return (
      <div className="mx-auto flex w-[350px] items-center gap-3 rounded-[10px] bg-Primary/Hover px-3 py-2 text-white">
        <Icon iconName="info-circle" variant="solid" />
        <Typography variant="body4">
          Xuất bản ngay để mọi người có thể thấy được bộ sưu tập của bạn
        </Typography>
        <LoadingButtonProvider
          isLoading={isLoading}
          className="flex-shrink-0 whitespace-nowrap rounded-full"
        >
          <Button
            onClick={() => {
              collection?.collectionId &&
                handlePublishCollection(collection.collectionId);
            }}
          >
            Xuất bản
          </Button>
        </LoadingButtonProvider>
      </div>
    );
  }

  return fallbackElement;
};

export default CollectionDetailOwnerStatusInteraction;
